/* eslint-disable react/prop-types */

import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  overflow: hidden;
  /*
    If the prototype doesn't have any background color it should
    default to white, like in the mac app

    https://github.com/sketch-hq/Cloud/issues/1717#issuecomment-585618001
   */
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.colors.white};
`

const ScrollContainer = styled.div`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  overflow: auto;
  position: relative;
  /* stylelint-disable property-no-unknown */
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
  /* stylelint-enable property-no-unknown */
  ${props =>
    props.hideScrollbars &&
    `&::-webkit-scrollbar {
    display: none;
  }`};
`

const FixedArea = styled.div`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
`

const ContentsArea = styled.div`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  position: relative;
  overflow: hidden;
`

const Artboard = props => {
  const {
    viewportWidth,
    viewportHeight,
    contentsWidth,
    contentsHeight,
    scrollContainerRef,
    scrollbarWidth,
    scrollbarHeight,
    hideScrollbarsOnWebkit,
    children,
    fixedChildren,
    backgroundColor,
    ...otherProps
  } = props

  const finalViewportWidth =
    contentsHeight > viewportHeight
      ? viewportWidth + scrollbarWidth
      : viewportWidth
  const finalViewportHeight =
    contentsWidth > viewportWidth
      ? viewportHeight + scrollbarHeight
      : viewportHeight

  return (
    <Container
      width={finalViewportWidth}
      height={finalViewportHeight}
      backgroundColor={backgroundColor}
      {...otherProps}>
      <FixedArea width={viewportWidth} height={viewportHeight}>
        {fixedChildren}
      </FixedArea>
      <ScrollContainer
        ref={scrollContainerRef}
        hideScrollbars={hideScrollbarsOnWebkit}
        width={finalViewportWidth}
        height={finalViewportHeight}>
        <ContentsArea width={contentsWidth} height={contentsHeight}>
          {children}
        </ContentsArea>
      </ScrollContainer>
    </Container>
  )
}

Artboard.propTypes = {
  viewportWidth: PropTypes.number.isRequired,
  viewportHeight: PropTypes.number.isRequired,
  contentsWidth: PropTypes.number.isRequired,
  contentsHeight: PropTypes.number.isRequired,
  children: PropTypes.node,
  fixedChildren: PropTypes.node,
  hideScrollbarsOnWebkit: PropTypes.bool,
  scrollbarWidth: PropTypes.number,
  scrollbarHeight: PropTypes.number,
  scrollContainerRef: PropTypes.shape({
    current: PropTypes.object,
  }),
  backgroundColor: PropTypes.string,
}

Artboard.defaultProps = {
  hideScrollbarsOnWebkit: false,
  scrollbarWidth: 0,
  scrollbarHeight: 0,
}

export default Artboard
